<mat-card class="auth mat-elevation-z">
	<mat-card-header class="flex-column align-items-center">
		<img [src]="'assets/images/auth/login.svg' | s3Image" alt="login" />

		<h1 class="v2">{{ translations[text.headerTitle] }}</h1>

		<p class="text-body-14px-regular fg-grey text-center m-0">
			{{ translations[text.headerDescription] }}
		</p>
	</mat-card-header>

	<form [formGroup]="form">
		<mat-card-content class="p-0">
			<app-input
				formControlName="phone"
				type="tel"
				placeholder="07XXXXXXXXX"
				[hint]="translations['n537']"
				[maxLength]="11"
				[prefix]="ngxMaskPhoneInput.prefix"
				[mask]="ngxMaskPhoneInput.mask"
				(focused)="onPhoneInputFocus()"
				(paste)="handlePaste($event)"
			></app-input>
		</mat-card-content>

		<mat-card-actions class="p-0 m-0">
			<app-button
				customClass="w-100 h-100"
				[label]="translations['n538']"
				[isDisabled]="form.invalid || isLoading"
				[isLoading]="isLoading"
				[hasSpinner]="true"
				(clicked)="onSendVerification()"
			></app-button>
		</mat-card-actions>
	</form>
</mat-card>
